// 互动活动列表
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

const ACTIVE_TYPE = {
  DAZHUANPAN: 'raffleActivity', // 抽奖
  QIANDAO: 'signInActivity', // 签到
  LINGQUAN: 'grantCoupons', // 领券
  BAOMING: 'signUpActivity', // 报名
};

const ACTIVE_TYPE_TEXT = [
  { type: ACTIVE_TYPE.DAZHUANPAN, text: '抽奖' },
  { type: ACTIVE_TYPE.QIANDAO, text: '签到' },
  { type: ACTIVE_TYPE.LINGQUAN, text: '领券' },
  { type: ACTIVE_TYPE.BAOMING, text: '报名' },
];

@DialogFactory
@Component({
  mixins: [style],
})
export default class Interactive extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '互动活动列表';

  activityType = '';
  mounted() {
    this.getData();
  }

  getData() {
    IPSService.interactiveList({
      postParams: {
        page: this.page,
        size: this.pageSize,
        activityType: this.activityType,
        siteCode: this.siteCodes[0],
        keyword: this.keyword,
      },
    }).then((resposne) => {
      this.dataList = (resposne.list || []).map((i) => {
        i.basicInfo.activityId = Functions.emptyVaribleHandler(i.basicInfo.activityId);
        i.basicInfo.activityType = Functions.emptyVaribleHandler(i.basicInfo.activityType);
        i.basicInfo.recUserName = Functions.emptyVaribleHandler(i.basicInfo.recUserName);
        i.basicInfo.statusName = Functions.emptyVaribleHandler(i.basicInfo.statusName);
        i.basicInfo.title = Functions.emptyVaribleHandler(i.basicInfo.title);
        return i;
      });
      this.total = resposne.total;
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  onPageChange(val) {
    this.page = val;
    this.getData();
  }

  handleSearch() {
    this.page = 1;
    this.getData();
  }

  onActTypeChange(val) {
    this.activityType = val;
    this.getData();
  }

  getType(activityType) {
    const actType = ACTIVE_TYPE_TEXT.find(v => v.type === activityType);
    return actType ? actType.text : '/';
  }

  onSelect(id, name, type) {
    this.$emit('result', { id, name, type });
    this.$emit('hidden');
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="活动ID/活动名称" />
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
          <el-select v-model={this.activityType} placeholder="活动类型" onChange={this.onActTypeChange.bind(this)}>
            <el-option label="全部" value="" />
            <el-option label="领券" value="grantCoupons" />
            <el-option label="抽奖" value="raffleActivity" />
            <el-option label="签到" value="signInActivity" />
            <el-option label="报名" value="signUpActivity" />
          </el-select>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="#" align="center" width="40" />
          <el-table-column
            prop="activityId"
            label="活动ID"
            width="100"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{scope.row.basicInfo.activityId}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="title"
            label="活动名称"
            width="280px"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{scope.row.basicInfo.title}</span>;
                },
              },
            }}
          />

          <el-table-column
            label="活动期间"
            align="center"
            width="350px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{`${scope.row.basicInfo.stimeStr}~${scope.row.basicInfo.etimeStr}`}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="activityTypeName"
            label="活动类型"
            align="center"
            width="140px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{this.getType(scope.row.basicInfo.activityType)}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="statusName"
            label="状态"
            align="center"
            width="140px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{scope.row.basicInfo.statusName}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="recUserName"
            label="更新人"
            align="center"
            width="140px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{scope.row.basicInfo.recUserName}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="recTimeStr"
            label="更新时间"
            align="center"
            width="140px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{scope.row.basicInfo.recTimeStr}</span>;
                },
              },
            }}
          />
          <el-table-column
            label="操作"
            width="80px"
            align="center"
            fixed="right"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.basicInfo.activityId, scope.row.basicInfo.title, scope.row.basicInfo.activityType)}>
                      选中
                    </span>
                  );
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
